// extracted by mini-css-extract-plugin
export default {"option":"ComprehensionView_option__kQMiO","img":"ComprehensionView_img__jj5P4"};